import { IRange } from '@jooxter/utils';
import { capitalize } from 'lodash-es';
import { DateTime } from 'luxon';

export const getButtonText = (range: IRange, viewType: string): string => {
  if (range && viewType) {
    const from = range.from;
    const to = range.to;

    const oneDay = from.toLocaleString(DateTime.DATE_MED);

    // Month View
    if (['dayGridMonth', 'listMonth', 'resourceTimelineMonth', 'paintMonthView'].includes(viewType)) {
      return `${capitalize(from.toFormat('LLL yyyy'))}`;
    }

    // remember that end is exclusive
    if (to.minus({ days: 1 }).hasSame(from, 'day')) {
      return oneDay;
    }

    // Week view
    if (['listWeek', 'dayGridWeek', 'resourceTimelineWeek', 'timeGridWeek', 'colleagueView'].includes(viewType)) {
      if (from.hasSame(to.minus({ days: 1 }), 'month')) {
        return `${from.day} - ${to.minus({ days: 1 }).day} ` + `${from.toFormat('MMM yyyy')}`;
      } else {
        return (
          `${from.day} ` + `${from.toFormat('LLL')} - ` + `${to.minus({ days: 1 }).day} ` + `${to.toFormat('LLL yyyy')}`
        );
      }
    }
  }

  return 'Invalid range or view type';
};
